import { createContext, useContext, useState } from "react";

const CartContext = createContext();
const ThemeAddCartContext = createContext();

export function useCart() {
  return useContext(CartContext);
}

export function useAddCart() {
  return useContext(ThemeAddCartContext);
}

export function GlobalThemeProvider({ children }) {

  const [items, setItems] = useState(0);

  const handleAddToCart = () => {
    setItems(items + 1);
  };

  // const [items, setItems] = useState([]);

  // const handleAddToCart = (product) => {
  //   setItems((prevItems) => [...prevItems, product]);
  // };
  //console.log("itemsoncartyyyy", items)
  return (
    <CartContext.Provider value={items}>
      <ThemeAddCartContext.Provider value={handleAddToCart}>
        {children}
      </ThemeAddCartContext.Provider>
    </CartContext.Provider>
  );
}


// import { createContext, useContext, useState } from "react";

// const CartContext = createContext();
// const ThemeAddCartContext = createContext();

// export function useCart() {
//   return useContext(CartContext);
// }

// export function useAddCart() {
//   return useContext(ThemeAddCartContext);
// }

// export function GlobalThemeProvider({ children }) {

//   const [cartItems, setCartItems] = useState([]);
//   // const [items, setItems] = useState(0);

//   //   const handleAddToCart = () => {
//   //     setItems(items + 1);
//   //   };

//   const handleAddCart = (product) => {
//     // Create a new item with the product details and add it to the cart items
//     const newItem = {
//       id: product.id,
//       ItemName: product.ItemName,
//       RetailSalesPriceExclGST: product.RetailSalesPriceExclGST,
//       DefaultStore: product.DefaultStore,
//       // Add any other details you want to save here
//     };
//     setCartItems((prevItems) => [...prevItems, newItem]);

//   };

//   return (
//     <CartContext.Provider value={cartItems}>
//       <ThemeAddCartContext.Provider value={handleAddCart}>
//         {children}
//       </ThemeAddCartContext.Provider>
//     </CartContext.Provider>
//   );
// }

